import React from 'react';
import { SearchResultLawyer } from './lawyer/SearchResultLawyer';
import { SearchResultLawfirm } from './lawfirm/SearchResultLawfirm';
import { LawfirmHit, LawyerHit } from '../../../search.types';

type Props = {
  hits: Array<LawfirmHit | LawyerHit>;
};

export class SearchResultLawyerOrLawfirm extends React.Component<Props> {
  render() {
    const { hits } = this.props;
    return (
      <>
        {hits.map(lawyerOrFirm =>
          lawyerOrFirm.type === 'lawyer' ? (
            <SearchResultLawyer
              key={lawyerOrFirm.lawyerId}
              lawyer={lawyerOrFirm}
            />
          ) : (
            <SearchResultLawfirm
              lawfirm={lawyerOrFirm}
              key={lawyerOrFirm.lawOfficeIdGroup}
            />
          ),
        )}
      </>
    );
  }
}
